// extracted by mini-css-extract-plugin
module.exports = {"posts__wrapp":"c_c"};